import { render, staticRenderFns } from "./PlainNavBar.vue?vue&type=template&id=52a70584&"
import script from "./PlainNavBar.vue?vue&type=script&lang=js&"
export * from "./PlainNavBar.vue?vue&type=script&lang=js&"
import style0 from "./PlainNavBar.vue?vue&type=style&index=0&id=52a70584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports